import * as Yup from 'yup';

import { signUpDayOptions } from '../../../defaultFilters';

export const useFirstSeenFilter = ({ setFilters }) => {
  const firstSeenOptions = signUpDayOptions;

  const formSchema = Yup.object().shape({
    daysSinceAdded: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.mixed().required(),
    }),
  });

  const onSubmit = ({ daysSinceAdded }) => {
    setFilters({ daysSinceAdded });
  };

  return {
    formSchema,
    onSubmit,
    firstSeenOptions,
  };
};
